export default __webpack_public_path__ + "assets/010687b1e207be60e66b23e82dd8183c.svg";